(() => {
  const normalize = value => String(value).trim().replace(/^gid:\/\/shopify\/Metaobject\//, '');
  async function init(sidebar) {
    const config = sidebar.dataset;
    const params = new URLSearchParams(location.search);
    const selected = params.getAll(config.modelParameter).flatMap(value => value.split(',')).map(normalize).filter(Boolean);
    if (!selected.length || sidebar.dataset.resultsReady) return;
    sidebar.dataset.resultsReady = 'true';
    const applied = (config.appliedModels || '').split(',').map(normalize);
    // Prefer Shopify's native filtering whenever it confirms the selection.
    if (selected.some(id => applied.includes(id))) return;
    const grid = document.querySelector('[data-vehicle-results]');
    const count = document.querySelector('[data-vehicle-result-count]');
    const pagination = document.querySelector('[data-vehicle-pagination]');
    if (!grid || !count) return;
    grid.hidden = true;
    if (pagination) pagination.hidden = true;
    count.textContent = 'Passende Produkte werden geladen …';
    const form = document.querySelector('[data-vehicle-search-form]');
    if (form) {
      const input = document.createElement('input');
      input.type = 'hidden'; input.name = config.modelParameter; input.value = params.getAll(config.modelParameter).join(',');
      form.append(input);
    }
    try {
      const hasSearch = config.query.trim() && config.query.trim() !== '*';
      let url = new URL(hasSearch ? config.searchUrl : config.catalogUrl, location.origin);
      url.searchParams.set('view', 'vehicle-products');
      if (hasSearch) { url.searchParams.set('q', config.query); url.searchParams.set('type', 'product'); }
      if (params.has('sort_by')) url.searchParams.set('sort_by', params.get('sort_by'));
      const cards = [];
      const visited = new Set();
      while (url) {
        if (url.origin !== location.origin || visited.has(url.href)) throw new Error('Invalid product pagination');
        visited.add(url.href);
        const response = await fetch(url.href, { credentials: 'same-origin' });
        if (!response.ok) throw new Error('Product request failed');
        const data = await response.json();
        if (!Array.isArray(data.entries)) throw new Error('Invalid product data');
        for (const entry of data.entries) {
          const models = String(entry.models || '').split(',').map(normalize);
          if (selected.some(id => models.includes(id)) && typeof entry.card === 'string') cards.push(entry.card);
        }
        url = data.next ? new URL(data.next, location.origin) : null;
        if (url) url.searchParams.set('view', 'vehicle-products');
      }
      // Cards are rendered and escaped by our own Shopify product-card snippet.
      grid.innerHTML = cards.slice(0, 24).join('');
      count.textContent = `${cards.length} passende Produkte`;
      grid.hidden = false;
      if (!cards.length) {
        const empty = document.createElement('p');
        empty.textContent = 'Für dieses Fahrzeug sind noch keine Produkte zugeordnet.';
        grid.append(empty);
      }
      if (cards.length > 24) {
        let shown = 24;
        const more = document.createElement('button');
        more.type = 'button'; more.className = 'button button-dark'; more.textContent = 'Weitere Produkte anzeigen';
        more.addEventListener('click', () => {
          grid.insertAdjacentHTML('beforeend', cards.slice(shown, shown + 24).join(''));
          shown += 24;
          if (shown >= cards.length) more.remove();
        });
        grid.after(more);
      }
    } catch {
      count.textContent = 'Die passenden Produkte konnten nicht geladen werden. Bitte lade die Seite erneut.';
    }
  }
  function start(root = document) {
    root.querySelectorAll('[data-vehicle-navigation]').forEach(sidebar => init(sidebar));
  }
  start();
  document.addEventListener('shopify:section:load', event => start(event.target));
})();
